

export default function PublisherList(){

    return(
            <div>
              <div className={`ai-body-medium bold ai-grey-100 map__publishers--active`}>IM 360</div>
            </div>
    )

}